import _ from 'lodash';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Icons from '../../../../../common/widgets/Icons';
import { config } from '../../../config';
import { PlatformInfoContext } from '../../../contexts/PlatformInfoContext';
import { resources } from '../../../resources/resources';

export default function PlatformInformation() {
  const { t: translate } = useTranslation();
  const platformInfo = useContext(PlatformInfoContext);

  if (_.isNull(platformInfo)) return null;

  return (
    <section className="page-section welcome-section">
      <div className="welcome-msg">
        <h1>
          {translate(resources.platformInformation.welcomeText, {
            0: platformInfo.customerFirstName,
          })}
        </h1>
        {platformInfo.platformBenefitsSelectionPeriodMessage !== '' && (
          <div>
            <Icons.Calendar />
            <span>{platformInfo.platformBenefitsSelectionPeriodMessage}</span>
          </div>
        )}
      </div>
      <div className="welcome-company">
        {!_.isNil(platformInfo.companyLogoPath) && (
          <img
            src={`${config.imagesUrl}/${platformInfo.companyLogoPath}`}
            alt={platformInfo.companyName}
          />
        )}
        <span className="company-name">
          <span>{platformInfo.companyName}</span>
        </span>
      </div>
    </section>
  );
}
